export default __webpack_public_path__ + "static/media/a016-2.487540ec.jpg";